import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { AlertTriangle, X } from 'lucide-react';
import { useTheme } from '../../contexts/ThemeContext';
import { apiDeleteUser } from '../../utils/api';
import { getAuthToken } from '../../utils/auth';

export const DeleteUserConfirmation = ({ user, onClose }) => {
    const { darkMode } = useTheme();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const handleDelete = async () => {
        setLoading(true);
        const token = getAuthToken();
        const data = await apiDeleteUser(token, user.id);
        setLoading(false);

        if (data.success) {
            onClose();
        } else {
            setError(data.error || 'Ошибка при удалении пользователя');
        }
    };

    return (
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-[70]"
            onClick={onClose}
        >
            <div
                className={`rounded-xl shadow-2xl w-full max-w-md p-6 ${
                    darkMode ? 'bg-gray-800' : 'bg-white'
                }`}
                onClick={e => e.stopPropagation()}
            >
                <div className="flex justify-between items-start mb-4">
                    <div className="flex items-center space-x-3">
                        <div className={`${darkMode ? 'bg-red-900' : 'bg-red-100'} p-2 rounded-lg`}>
                            <AlertTriangle className={`w-6 h-6 ${darkMode ? 'text-red-400' : 'text-red-600'}`} />
                        </div>
                        <h2 className={`text-xl font-bold ${darkMode ? 'text-white' : 'text-gray-800'}`}>
                            Удаление пользователя
                        </h2>
                    </div>
                    <button
                        onClick={onClose}
                        className={`${darkMode ? 'text-gray-400 hover:text-gray-200' : 'text-gray-500 hover:text-gray-700'}`}
                    >
                        <X className="w-6 h-6" />
                    </button>
                </div>

                {error && (
                    <div className={`mb-4 p-3 rounded-lg text-sm ${
                        darkMode ? 'bg-red-900/50 text-red-300' : 'bg-red-50 text-red-600'
                    }`}>
                        {error}
                    </div>
                )}

                <p className={`mb-2 ${darkMode ? 'text-gray-300' : 'text-gray-600'}`}>
                    Вы уверены, что хотите удалить пользователя:
                </p>
                <p className={`font-bold text-lg mb-4 ${darkMode ? 'text-white' : 'text-gray-800'}`}>
                    {user.name} ({user.username})
                </p>
                <p className={`text-sm mb-6 p-3 rounded-lg ${
                    darkMode ? 'bg-yellow-900/30 text-yellow-300 border border-yellow-800' : 'bg-yellow-50 text-yellow-800'
                }`}>
                    <strong>Важно:</strong> Будут удалены все отчеты TimeSheet и переработки этого пользователя. Это действие необратимо.
                </p>

                <div className="flex justify-end space-x-3">
                    <button
                        onClick={onClose}
                        className={`px-4 py-2 rounded-lg transition-colors ${
                            darkMode ? 'text-gray-300 hover:bg-gray-700' : 'text-gray-700 hover:bg-gray-100'
                        }`}
                        disabled={loading}
                    >
                        Отмена
                    </button>
                    <button
                        onClick={handleDelete}
                        disabled={loading}
                        className={`px-4 py-2 rounded-lg transition-colors flex items-center ${
                            darkMode ? 'bg-red-600 hover:bg-red-700 text-white' : 'bg-red-600 hover:bg-red-700 text-white'
                        } ${loading ? 'opacity-75 cursor-not-allowed' : ''}`}
                    >
                        {loading ? 'Удаление...' : 'Удалить пользователя'}
                    </button>
                </div>
            </div>
        </motion.div>
    );
};